import { seoService } from './seo';
import { settingsService } from './settings';

export default {
  seo: seoService,
  settings: settingsService,
};
